import { Link } from 'react-router-dom';
import { COMICS } from '@/mocks/comics';
import SectionHeading from '@/components/base/SectionHeading';

function formatViews(n: number) {
  if (n >= 10000) return `${(n / 10000).toFixed(1).replace(/\.0$/, '')}万`;
  return `${n}`;
}

export default function RankSection() {
  const rank = [...COMICS].sort((a, b) => b.views - a.views).slice(0, 6);
  return (
    <section className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          <div className="lg:col-span-1">
            <SectionHeading eyebrow="热门榜单" title="人气飙升榜" desc="读者用脚投票出来的高人气作品，不知道看什么就跟着榜单走。" accent />
            <div className="mt-6 flex flex-col gap-3">
              {[1, 2, 3].map((n) => (
                <div key={n} className="flex items-center gap-3 rounded-xl border border-background-200/70 bg-background-50 p-3">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-500 text-sm font-bold text-background-50">
                    {n}
                  </span>
                  <div className="h-2.5 flex-1 overflow-hidden rounded-full bg-background-200">
                    <div className="h-full rounded-full bg-gradient-to-r from-primary-500 to-accent-500" style={{ width: `${100 - (n - 1) * 25}%` }}></div>
                  </div>
                  <span className="text-xs text-foreground-500">{100 - (n - 1) * 25}%</span>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-2">
            <div className="flex flex-col gap-3">
              {rank.map((c, idx) => (
                <Link
                  key={c.id}
                  to={`/article/${c.id}`}
                  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  className="group flex items-center gap-4 rounded-xl border border-background-200/70 bg-background-50 p-3 transition-colors hover:border-primary-200"
                >
                  <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg text-lg font-bold ${idx < 3 ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-600'}`}>
                    {idx + 1}
                  </span>
                  <img src={c.cover} alt="" loading="lazy" className="h-16 w-12 shrink-0 rounded-lg object-cover object-top" />
                  <div className="min-w-0 flex-1">
                    <h3 className="truncate font-bold text-foreground-950 group-hover:text-primary-600">{c.title}</h3>
                    <p className="mt-0.5 truncate text-xs text-foreground-500">{c.category} · {c.author}</p>
                  </div>
                  <div className="flex shrink-0 items-center gap-4 text-sm text-foreground-500">
                    <span className="flex items-center gap-1 text-accent-700">
                      <i className="ri-star-fill"></i>
                      {c.rating}
                    </span>
                    <span className="hidden items-center gap-1 sm:flex">
                      <i className="ri-eye-line"></i>
                      {formatViews(c.views)}
                    </span>
                    <i className="ri-arrow-right-s-line text-xl text-foreground-300"></i>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}